import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

import {
  isPendingAction,
  isRejectedAction,
  isFulfilledAction
} from './actions';

import { applicationData } from './mockData/applicationData';

const name = 'applications';

export const getApplications = createAsyncThunk(
  `${name}/getApplications`,
  async (_, { rejectWithValue }) => {
    try {
      //const responseFromApi = await axios.get('/api/applications');

      const response = applicationData;
      //return response;
      return responseFromApi;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const applicationSlice = createSlice({
  name,
  initialState: {
    loading: false,
    errors: false,
    applications: applicationData
  },
  reducers: {
    updateApplications: (state, action) => {
      state.applications = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getApplications.fulfilled, (state, action) => {
        const { applications } = action.payload;

        state.applications = applications;
      })
      .addMatcher(isPendingAction(name), (state) => {
        state.loading = true;
        state.errors = false;
      })
      .addMatcher(isRejectedAction(name), (state, action) => {
        state.loading = false;
        state.errors = action.payload;
      })
      .addMatcher(isFulfilledAction(name), (state) => {
        state.loading = false;
      });
  }
});

export const { updateApplications } = applicationSlice.actions;
export default applicationSlice.reducer;
